import DateInputField from './DateInputField.view';
export default DateInputField;
